import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import materialProduto from "../../enums/materialProduto";

export default function Catalogo(props) {
  const [usuarioId] = useState(Number(props.match.params.usuarioId));
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [usuariosGrupoPedidos, setUsuariosGrupoPedidos] = useState([]);
  const [usuario, setUsuario] = useState({});
  const [filtros, setFiltros] = useState({});
  const [produtoSelecionado, setProdutoSelecionado] = useState({});
  const [produtoCategorias, setProdutoCategorias] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const history = props.history;

  useEffect(() => {
    listarUsuariosGrupoPedidos();
    listarProdutoCategorias();
  }, []);

  const listarUsuariosGrupoPedidos = () => {
    setCarregando(true);
    api
      .get("grupos/membros", {
        grupoCodIdentificador: "PAINEL_ESCOLAS_PEDIDOS",
      })
      .then((usuariosGrupoPedidos) => {
        usuariosGrupoPedidos.forEach(
          (u) =>
            (u.escolaProfissional = `${u.escolaNomeFantasia} - ${u.usuarioNome}`)
        );

        usuariosGrupoPedidos.sort((a, b) => {
          if (a.escolaProfissional > b.escolaProfissional) return 1;

          return -1;
        });

        if (usuarioId > 0) {
          usuariosGrupoPedidos
            .filter((u) => u.usuarioId === Number(usuarioId))
            .forEach((u) => {
              setUsuario(u);
              carregarCatalogo(u);
            });
        }

        setUsuariosGrupoPedidos(usuariosGrupoPedidos);

        setCarregando(false);
      })
      .catch((e) =>
        notification("warning", "Erro ao carregar grupos de membros")
      );
  };

  const carregarCatalogo = (filtros) => {
    const paramCatalogo = {
      usuarioId: usuarioId,
    };

    if (filtros.usuarioId) {
      paramCatalogo.usuarioId = filtros.usuarioId;
    }
    if (filtros.nome) {
      paramCatalogo.nome = filtros.nome;
    }
    if (filtros.categoriaId) {
      paramCatalogo.categoriaId = filtros.categoriaId;
    }
    if (filtros.produtoPerto) {
      paramCatalogo.produtoPerto = filtros.produtoPerto;
    }

    setFiltros(paramCatalogo);
    // R$ c.valorVenda / 100
    setCarregando(true);
    api
      .get("produtos/catalogo", paramCatalogo)
      .then((catalogo) => {
        catalogo.forEach((c) => (c.valor = `R$  ${c.valorVenda / 100} `));
        setCatalogo(catalogo);
        setCarregando(false);
      })
      .catch((e) => notification("warning", "Erro ao carregar catalogo"));
  };

  const listarProdutoCategorias = () => {
    api
      .get("produtos/listarCategorias")
      .then((produtoCategorias) => {
        setProdutoCategorias(produtoCategorias);
      })
      .catch((err) => {
        console.log(err);
        notification("warning", "Erro ao listar as categorias de produtos.");
      });
  };

  const selecionarUsuarioPedido = (form) => {
    usuariosGrupoPedidos
      .filter((u) => u.usuarioId === Number(form.usuarioId))
      .forEach((u) => {
        setUsuario(u);
        carregarCatalogo(u);
      });
  };

  const fSelecaoUsuarioPedido = {
    form: usuario.usuarioId
      ? {
          escolaProfissional: {
            label: "Componente",
            type: "component",
            // space: 6,
            value: (
              <div>
                <h4>Escola/Profissional</h4>
                <p>{usuario.escolaProfissional}</p>
              </div>
            ),
          },
        }
      : {
          usuarioId: {
            name: "Escola/Profissional",
            type: "select",
            value: usuario.usuarioId,
            array: {
              data: usuariosGrupoPedidos,
              value: "usuarioId",
              desc: "escolaProfissional",
            },
            emptyItem: true,
            emptyItemText: "(Selecione)",
            emptyItemValue: 0,
          },
        },
    title: "Escola e profissional do pedido",
    submit: usuario.usuarioId
      ? undefined
      : {
          label: "Confirmar",
          action: selecionarUsuarioPedido,
        },
    customActions: usuario.usuarioId
      ? [
          {
            label: "Alterar",
            action: () => setUsuario({}),
          },
        ]
      : undefined,
  };

  const camposFiltros = () => {
    return {
      nome: {
        label: "Nome",
        type: "text",
        value: filtros.nome,
        space: 6,
      },
      categoriaId: {
        label: "Categoria",
        type: "select",
        emptyItem: true,
        array: {
          data: produtoCategorias,
          value: "id",
          desc: "nome",
        },
        value: filtros.produtoCategoriaId,
        space: 3,
      },

      produtoPerto: {
        label: "Produto Perto",
        type: "select",
        emptyItem: true,
        space: 3,
        options: [
          {
            value: 1,
            desc: "Bilíngue",
          },
          {
            value: 2,
            desc: "Uni Dune Tê",
          },
        ],
        value: filtros.produtoPerto,
      },
    };
  };

  const fFiltro = {
    form: camposFiltros(),
    title: "Buscar produto",
    history,
    submit: {
      label: "Buscar",
      action: carregarCatalogo,
    },

    close: { label: "Cancelar" },
  };

  const tRegistros = {
    title: "Itens",
    onLineClick: (produtoSelecionado) =>
      setProdutoSelecionado(produtoSelecionado),

    columns: [
      {
        name: "nome",
        label: "Produto",
      },
      {
        name: "categoriaNome",
        label: "Categoria",
      },
      {
        name: "valor",
        label: "Valor (R$)",
      },
      {
        name: "produtoPerto",
        label: "Produto Perto",
        domain: materialProduto,
      },
    ],
    array: catalogo,
  };

  const adicionarProdutoCarrinho = (form) => {
    if (!form.quantidade || form.quantidade < 1)
      return notification("warning", "Quantidade inválida");

    const item = {
      usuarioId: usuario.usuarioId,
      produtoId: produtoSelecionado.id,
      valor: produtoSelecionado.valorVenda * 100,
      quantidade: form.quantidade,
    };

    api
      .post("carrinhos/inserirItem", item)
      .then((res) => {
        notification("success", "Carrinho atualizado");
        // carregarCatalogo();
        history.push(`/app/carrinho/carrinho/${usuarioId}`);

        setProdutoSelecionado({});
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Usuário inválido");
          case 2:
            return notification("error", "Quantidade inválida");
          case 3:
            return notification("error", "Valor inválido");
          case 4:
            return notification("error", "Produto inválido");
          case 5:
            return notification(
              "error",
              "Produto com venda exclusiva para outra(s) escola(s)"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fProdutoSelecionado = {
    title: "Produto",
    form: {
      nome: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Produto</h4>
            <p>{produtoSelecionado.nome}</p>
          </div>
        ),
      },

      categoria: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Categoria</h4>
            <p>{produtoSelecionado.categoriaNome}</p>
          </div>
        ),
      },

      valor: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Valor</h4>
            <p>R$ {produtoSelecionado.valor}</p>
          </div>
        ),
      },

      descricao: {
        label: "Componente",
        type: "component",
        // space: 4,
        value: (
          <div>
            <h4>Descrição</h4>
            <p>{produtoSelecionado.descricao}</p>
          </div>
        ),
      },

      altura: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Altura (cm)</h4>
            <p>{produtoSelecionado.altura}</p>
          </div>
        ),
      },

      largura: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Largura (cm)</h4>
            <p>{produtoSelecionado.largura}</p>
          </div>
        ),
      },
      peso: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Peso (g)</h4>
            <p>{produtoSelecionado.peso}</p>
          </div>
        ),
      },

      quantidade: {
        label: "Quantidade",
        type: "number",
        // space: 5,
        value: 1,
      },
    },
    submit: {
      label: "Adicionar ao carrinho",
      action: adicionarProdutoCarrinho,
    },
    close: {
      label: "fechar",
      action: () => {
        setProdutoSelecionado({});
      },
    },
  };

  return (
    <div>
      <Form formData={fSelecaoUsuarioPedido} />

      {usuario.usuarioId && (
        <>
          <Form formData={fFiltro} />
          {carregando ? (
            <CircularProgress />
          ) : produtoSelecionado.id ? (
            <Form formData={fProdutoSelecionado} />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      )}
    </div>
  );
}
